import { fetchContentLogic } from './fetchContentLogic';

export const logic = [fetchContentLogic];
